import { render, staticRenderFns } from "./EspondiloartritesSymptomsPhase.vue?vue&type=template&id=bd456b3c&"
import script from "./EspondiloartritesSymptomsPhase.vue?vue&type=script&lang=js&"
export * from "./EspondiloartritesSymptomsPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports